// Westmoreland — Private Bank
export const META = { brand: 'Westmoreland', tagline: 'Private Bank · since 1908', motto: 'A bank held by the families it serves.' };

export const ROUTES = [
  { id: 'home', label: 'The House' },
  { id: 'practice', label: 'Practice' },
  { id: 'view', label: 'House View' },
  { id: 'introduce', label: 'Introduce' },
];

export const STATS = [
  { v: '$84.2bn', l: 'Assets under stewardship', n: 'AUS-2025-Q4' },
  { v: '4.7×', l: 'Cap. ratio above regulatory floor', n: 'CAP-2025' },
  { v: '127', l: 'Families, four generations or more', n: 'CL-FAM' },
  { v: '0.34%', l: 'Average client attrition, 10-yr', n: 'ATR-DEC' },
];

export const PRACTICES = [
  { id: '01', t: 'Wealth Management', d: 'Discretionary and advisory portfolios for individuals and trusts. Open architecture &mdash; we are paid by you, not by the funds. Minimum $25M.', staff: '14 partners' },
  { id: '02', t: 'Family Office', d: 'Consolidated reporting, governance, generational planning and bespoke private credit for principal families. Minimum $100M.', staff: '23 partners' },
  { id: '03', t: 'Private Lending', d: 'Bespoke balance-sheet lending, art- and yacht-secured credit, bridge financing for transactional liquidity. Minimum facility $10M.', staff: '8 partners' },
];

export const VIEWS = [
  { tag: 'House View · Macro', d: '14 Feb 2026', t: 'Three rate cuts will not arrive in 2026, and we are positioned for it', auth: 'Marcus Whitford, Chief Investment Officer', read: '12 min' },
  { tag: 'House View · Credit', d: '03 Feb 2026', t: 'Senior secured remains the only sleeve we are adding to', auth: 'Helena Voss, Head of Credit', read: '7 min' },
  { tag: 'Letter to clients · Q4', d: '12 Jan 2026', t: 'On private equity returns: a quarter of caution, not pessimism', auth: 'James Westmoreland Jr., Chairman', read: '14 min' },
];

export const PARTNERS = [
  { name: 'James Westmoreland Jr.', role: 'Chairman · 4th generation', bio: '34 years at the bank. Joined 1991. Read economics at Cambridge.' },
  { name: 'Marcus Whitford', role: 'Chief Investment Officer', bio: 'Joined from Brevan Howard, 2013. Twenty-two years macro. CFA.' },
  { name: 'Helena Voss', role: 'Head of Credit', bio: 'Joined from Goldman Sachs, 2017. Specialist in private credit underwriting.' },
];
